import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TopicListVisibleService } from '../../../home/services/topic-list-visible.service';
import { NgClass, NgStyle } from '@angular/common';
import { AnimIconComponent } from '@coin/shared/core/feature-legacy-components';

@Component({
  selector: 'customer-app-arrow-toggle-button',
  templateUrl: './arrow-toggle-button.component.html',
  styleUrls: ['./arrow-toggle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, AnimIconComponent, NgStyle]
})
export class ArrowToggleButtonComponent implements OnInit {
  private readonly topicListVisible = inject(TopicListVisibleService);
  private readonly destroyRef = inject(DestroyRef);

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() toggle = new EventEmitter<void>();
  readonly mode = input('horizontal'); // default
  readonly isTopicListView = input(false);
  @Input() isDefaultValue = true;

  ngOnInit(): void {
    if (this.isTopicListView()) {
      this.topicListVisible.change$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(tlv => {
        this.isDefaultValue = !!tlv;
      });
    }
  }

  toggleIt(): void {
    this.toggle.emit();
  }
}
